import { faArrowUpRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "@tanstack/react-router";

type ProductBoxProps =
    | { title: string; href: string; to?: never; params?: never }
    | {
          title: string;
          href?: never;
          to: "/$customerId/pulse/$pulseId";
          params: { customerId: string; pulseId: string };
      };

export default function ProductBox({ title, href, to, params }: ProductBoxProps) {
    const content = (
        <>
            <FontAwesomeIcon icon={faArrowUpRight} size="xl" className="self-end text-xl w-[1em]" />
            <div className="text-2xl truncate text-nowrap">{title}</div>
        </>
    );

    if (to) {
        return (
            <Link
                to={to}
                params={params}
                className="border-4 p-2 transition-all ease-in-out duration-150 hover:scale-120 border-on-bg-image text-on-bg-image font-medium backdrop-blur-xs h-24 max-w-60 bg-black/20 dark:bg-white/16 flex flex-col justify-between"
            >
                {content}
            </Link>
        );
    }

    return (
        <a
            href={href}
            className="border-4 p-2 transition-all ease-in-out duration-150 hover:scale-120 border-on-bg-image text-on-bg-image font-medium backdrop-blur-xs h-24 max-w-60 bg-black/20 dark:bg-white/16 flex flex-col justify-between"
        >
            {content}
        </a>
    );
}
